import React from 'react';
import {
  Box,
  Heading,
  OrderedList,
  ListItem,
  Button,
  Link,
} from '@chakra-ui/react';

const MeasurementSummaryList = () => (
  <Box marginBottom={['0', '0', '0', '30%']}>
    <Heading mb={12} color="blue.500">
      Why do architects and designers use HOVER?
    </Heading>
    <OrderedList mb={12} spacing={8}>
      <ListItem>
        Get accurate measurements of the entire exterior of a home including
        siding, roofing, fascia and more
      </ListItem>
      <ListItem>
        Export your HOVER model into popular CAD file types (SKP, DWG, DXF) to
        use in your favorite softwares (SketchUp, AutoCAD, etc.)
      </ListItem>
      <ListItem>Save time and money during the Schematic Design stage</ListItem>
    </OrderedList>
    <Link href="https://calendly.com/hover-sdr/hover-architect" target="_blank">
      <Button size="lg" whiteSpace="normal" wordwrap="break-word" minW="100%">
        Schedule Time with Sales to Learn More
      </Button>
    </Link>
  </Box>
);
export default MeasurementSummaryList;
